import { Component, inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { DynamicFormService } from '@ntap/common';
import { PrimeNGInputDropdownComponent } from '@ntap/primeng';
import { BehaviorSubject, filter, map, switchMap, tap } from 'rxjs';
import { type IntegrationSearchResult } from './integration-search.component';

@Component({
  selector: 'app-viaf-integration',
  template: `
    <ng-container *ngIf="inputConfig$ | async as inputConfig">
      <app-integration-search
        [inputConfig]="inputConfig"
        [control]="viafLocationFormContol"
        (searchResult)="onSearchResult($event)"
        searchType="viaf"
        displayLabel="label"
        subheaderLabel="country"
        linkTooltip="Pregled osobe na viaf web stranici."
        placeholder="Viaf osoba"
        linkBase="https://www.viaf.org/viaf"
        unavailableLabel="VIAF zapis trenutno nedostupan"
      >
      </app-integration-search>
    </ng-container>
  `
})
export default class ViafIntegrationInputComponent
  extends PrimeNGInputDropdownComponent
  implements OnInit
{
  public viafLocationFormContol: FormControl;
  public searchResults$ = new BehaviorSubject<IntegrationSearchResult[]>([]);

  private dynamicFormService = inject(DynamicFormService);

  override ngOnInit(): void {
    const initialValue = this.formControl.value;

    this.viafLocationFormContol = new FormControl(
      initialValue,
      Validators.required
    );

    this.addSubscription(
      this.viafLocationFormContol.valueChanges.subscribe((id) => {
        this.formControl.setValue(id);
      })
    );

    this.addSubscription(
      this.dynamicFormService.formGroup$
        .pipe(
          switchMap((fg) => {
            return this.viafLocationFormContol.valueChanges.pipe(
              switchMap((id) =>
                this.searchResults$.pipe(
                  map((results) => results.filter((l) => l.id === id)),
                  map((filteredResults) => filteredResults[0]),
                  filter((selected) => !!selected),
                  tap(() => {
                    fg.setValue({
                      ...fg.value
                    });
                  })
                )
              )
            );
          })
        )
        .subscribe()
    );
  }

  public onSearchResult(searchResult: IntegrationSearchResult[]) {
    this.searchResults$.next(searchResult);
  }
}
